import React, { useEffect, useState } from 'react';
import { Popup } from '../../../../../ui/Modal/Popup';
import { LoaderContainer, LoaderEnum, MiniLoader } from '../../../../../ui/Loader/MiniLoader';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { AgreementTextRow, PersonalDataAgreementContainer } from '../styles';
import { IconContainer } from '../../../../../components/ui/Content';
import { Body1, Body1PointerLink } from '../../../../../components/Font';
import { CheckBoxOff, CheckBoxOn } from '../../../../../icon/Icon';
import { AgreementType } from '../functions/checkRegFormFunctions';

interface IProps {
	agreementGiven: boolean;
	setAgreementGiven: (value: boolean) => void;
	agreementModalType: AgreementType | null;
	setAgreementModalType: (value: AgreementType | null) => void;
}

export const PersonalDataAgreement: React.FC<IProps> = ({
	agreementGiven,
	setAgreementGiven,
	agreementModalType,
	setAgreementModalType,
}) => {
	const [iframeLoaded, setIframeLoaded] = useState(false);
	const { t } = useTranslation();
	const Theme = useTheme();

	useEffect(() => {
		if (agreementModalType === null) {
			setIframeLoaded(false);
		}
	}, [agreementModalType]);

	const iframeLoadedHandler = () => setIframeLoaded(true);
	return (
		<>
			<Popup
				opened={agreementModalType !== null}
				style={{ padding: '0' }}
				styleHeader={{ padding: '9px 8px 0' }}
				onClose={() => {
					setAgreementModalType(null);
				}}
			>
				<>
					{agreementModalType === AgreementType.personalDataProcessing && (
						<iframe onLoad={iframeLoadedHandler} src={t('registrationPage.personalDataProcessingLink')} />
					)}
					{agreementModalType === AgreementType.confidentialPolicy && (
						<iframe onLoad={iframeLoadedHandler} src={t('registrationPage.policyLink')} />
					)}
					{!iframeLoaded && (
						<LoaderContainer>
							<MiniLoader color={Theme.color.indicator} size={LoaderEnum.medium} />
						</LoaderContainer>
					)}
				</>
			</Popup>

			<PersonalDataAgreementContainer>
				<IconContainer onClick={() => setAgreementGiven(!agreementGiven)}>
					{agreementGiven ? <CheckBoxOn /> : <CheckBoxOff />}
				</IconContainer>
				<AgreementTextRow>
					<Body1>{t('registrationPage.checkBoxCaption1')}</Body1>
					<Body1PointerLink
						onClick={() => {
							setAgreementModalType(AgreementType.personalDataProcessing);
						}}
					>
						{t('registrationPage.checkBoxCaptionLink')}
					</Body1PointerLink>
					<Body1>{t('registrationPage.checkBoxCaption2')}</Body1>
					<Body1PointerLink
						onClick={() => {
							setAgreementModalType(AgreementType.confidentialPolicy);
						}}
					>
						{t('registrationPage.checkBoxCaptionLink2')}
					</Body1PointerLink>
				</AgreementTextRow>
			</PersonalDataAgreementContainer>
		</>
	);
};
